import { Component, ReactNode } from "react";
import classNames from "classnames";
import NextImage from "next/image";

import styles from "./styles/image.module.scss";
import filters from "./styles/filters.module.scss";

interface IImageProps {
  imageUrl: string;
  isBackground?: boolean;
  backgroundType?: "cover" | "repeatX" | "repeatY";
  height?: string;
  width?: string;
  filter?: string | null;
  description?: string;
  isWelcomePage?: boolean;
  children?: ReactNode;
  priority: boolean;
}

export default class Image extends Component<IImageProps> {
  static defaultProps = {
    height: "100%",
    width: "100%",
    isBackground: false,
    filter: null,
    priority: false,
  };

  static filterMap: Record<string, string> = {
    darkGradient: filters.darkGradient,
  };

  render() {
    const {
      imageUrl,
      isBackground,
      backgroundType,
      filter,
      description,
      priority,
    } = this.props;

    let imgTag;
    if (isBackground) {
      const className = classNames({
        [styles.repeatX]: backgroundType === "repeatX",
        [styles.repeatY]: backgroundType === "repeatY",
        [styles.cover]: backgroundType === "cover",
        [styles.coverWelcomePage]:
          backgroundType === "cover" && this.props.isWelcomePage,
      });

      let filterObj;
      if (filter) {
        filterObj = <div className={Image.filterMap[filter]} />;
      }

      imgTag = (
        <div role="presentation" aria-label={description}>
          <div key={imageUrl} className={className}>
            <NextImage
              src={imageUrl}
              alt={description ?? ""}
              fill
              objectFit={backgroundType}
              priority={priority}
            />
          </div>
          {filterObj}
        </div>
      );
    } else {
      imgTag = (
        <img
          loading={"lazy"}
          key={imageUrl}
          src={imageUrl}
          title={description}
        />
      );
    }

    const containerClassName = classNames({
      [styles.container]: backgroundType !== undefined,
    });

    return (
      <div className={containerClassName}>
        {imgTag}
        {this.props.children}
      </div>
    );
  }
}
